(function () {
    'use strict';

    angular.module("imApp").factory("equipmentGrpLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 2051,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 2052,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
